import { motion } from "framer-motion";
import { Package, Gamepad2, RotateCcw } from "lucide-react";

const steps = [
  {
    icon: Gamepad2,
    title: "Choose your duration",
    desc: "Pick 3, 7, or 14 days. Pay securely with Razorpay.",
  },
  {
    icon: Package,
    title: "We deliver it to you",
    desc: "Your Quest 3 arrives at your door, fully charged and loaded with apps.",
  },
  {
    icon: RotateCcw,
    title: "Return when done",
    desc: "Schedule a pickup. We handle the rest. No hidden fees.",
  },
];

const HowItWorks = () => {
  return (
    <section className="py-24 md:py-36 px-6">
      <div className="max-w-narrative mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-heading text-3xl md:text-5xl font-bold text-foreground text-center mb-20"
        >
          How it works
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="text-center"
            >
              <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-muted flex items-center justify-center">
                <step.icon className="w-7 h-7 text-secondary" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-3">
                {step.title}
              </h3>
              <p className="font-body text-sm text-muted-foreground leading-relaxed">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
